export const SITE = {
  brand: "Cabo Yoga & Fitness",
  url: "https://caboyogaandfitness.com",
  bookingPath: "/booking",
  bookingUrl: "https://caboyogaandfitness.com/booking",
  privateExperiencesEmail: "caboyogafitness@gmail.com",
  contact: {
    email: "caboyogafitness@gmail.com",
    phone: "+52 (55) 7010-4711",
    phoneE164: "+525570104711",
    address: ["Plaza Nova", "Cabo San Lucas, Baja California Sur", "Mexico"],
    maps: "https://maps.app.goo.gl/32kRosB8XhrHGjK99",
    facebook: "https://www.facebook.com/Caboyogafitness",
    instagram: "https://www.instagram.com/cabo_yogafitness",
    whatsapp: "https://wa.me/5215570104711",
  },
  navigation: [
    { key: "classes", href: "/classes" },
    { key: "experiences", href: "#private-experiences" },
    { key: "sound", href: "/sound-healing" },
    { key: "about", href: "#about" },
  ],
  fitco: {
    scriptUrl: "https://spa.fitcoapp.net/fitco.home.js",
    establishmentId: "2784",
    calendarPath: "/booking",
    plansPath: "/booking",
    profileButtonSelector: ".user-accounts-link.header-nav-item",
  },
};
